import { JobStatus } from '../generated/graphql';

export type ScheduleEventKeyInput = {
  id?: string | number | null;
  status?: JobStatus | string | null;
  summary?: string | null;
  site_id?: string | number | null;
  siteId?: string | number | null;
};

const BOOKING_LABEL = 'Booking';

const normalizeKeyPart = (
  value: string | number | null | undefined,
  fallback: string
): string => {
  if (value === null || value === undefined || value === '') return fallback;
  return String(value);
};

export const isBookingEvent = (
  event?: ScheduleEventKeyInput | null
): boolean => {
  if (!event) return false;
  const statusLabel =
    event.status === null || event.status === undefined
      ? null
      : String(event.status);
  if (statusLabel === BOOKING_LABEL) return true;
  if (event.summary === BOOKING_LABEL) return true;
  return false;
};

export const getScheduleEventCompositeKey = (
  event: ScheduleEventKeyInput | null | undefined,
  siteIdOverride?: string | number | null
): string => {
  const typePrefix = isBookingEvent(event) ? 'booking' : 'job';
  const sitePart = normalizeKeyPart(
    siteIdOverride ?? event?.site_id ?? event?.siteId,
    'na'
  );
  const idPart = normalizeKeyPart(event?.id, 'unknown');

  return `${typePrefix}:${sitePart}:${idPart}`;
};
